export const formatCurrency = (amount: number, currency: string) => {
	const formattedAmount = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: currency || 'USD',
		minimumFractionDigits: 2,
	}).format(amount);

	return formattedAmount;
};
